export default "__VITE_ASSET__B1XiyqXD__"